import { components } from "@apiSchema";

export enum TerrainEnum {
    Urban = "Urban",
    Suburban = "Suburban",
    Rural = "Rural"
}
export interface iTerrain {
    name: TerrainEnum;
    stores: number;
    percentLocation: number;
}

export class Terrain implements iTerrain {
    name = TerrainEnum.Urban;
    stores = 0;
    percentLocation = 0;

    constructor(data?: iTerrain) {
        if (data) {
            this.setData(data);
        }
    }

    static parseAllFromApi(data: components['schemas']['LocationsRootObject'] = {}): iTerrain[] {
        return [
            {
                name: TerrainEnum.Urban,
                stores: data.urbanCount ?? 0,
                percentLocation: data.urbanPercent ?? 0,
            },
            {
                name: TerrainEnum.Suburban,
                stores: data.suburbanCount ?? 0,
                percentLocation: data.suburbanPercent ?? 0,
            },
            {
                name: TerrainEnum.Rural,
                stores: data.ruralCount ?? 0,
                percentLocation: data.ruralPercent ?? 0,
            },
        ];
    }

    private setData(data: iTerrain) {
        ({
            name: this.name,
            percentLocation: this.percentLocation,
            stores: this.stores,
        } = data);
    }
}